import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {RadioTagsPresenter} from "./radioTagsPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class RadioTagsView extends ViewBase implements IView {

    public _presenter: RadioTagsPresenter;
    private _value: any;

    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer) {
        super(viewName, router, dependencyContainer);


    }

    public dataBind(items: Record<string, any>, tagName: string = null) {
        
        this.renderModelsUnder(items, tagName);
        
        this.$element.querySelectorAll(`input[name="${tagName}"]`).forEach((radio) => {
            radio.addEventListener('change', () => {
                const selected = this.$element.querySelector(`input[name="${tagName}"]:checked`);
                this._value = selected.value;
                console.log('Selected:', selected.value);
            });
        });

    }

    public setPresenter(presenter: RadioTagsPresenter) {
        this._presenter = presenter;
    }

    public get value() {
        return this._value;
    }

    public render(): void {
    }

}